import { render, staticRenderFns } from "./AzChat.vue?vue&type=template&id=6dc90418&"
import script from "./AzChat.vue?vue&type=script&lang=js&"
export * from "./AzChat.vue?vue&type=script&lang=js&"
import style0 from "./AzChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports